import { inject, Injectable, Injector } from '@angular/core';
import { BaseService } from '@libs/vc-core-lib';
import { IFilterCriteriaDTO } from '../dto/filter.criteria.dto';
import { IFilterModel } from '../model/filter.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FilterService extends BaseService<IFilterModel> {
    constructor() {
        super(inject(Injector), 'filters');
    }

    public searchWithoutPaging(searchDTO: IFilterCriteriaDTO): Observable<Array<IFilterModel>> {
        return this.httpClient.post<Array<IFilterModel>>(
            `${this.environment.APP.VC_EVENT_DECORATOR_BASE_URL}/${this.serviceBaseUrl}/search`,
            searchDTO
        );
    }

    public get(id: number): Observable<IFilterModel> {
        return this.httpClient.get<IFilterModel>(
            `${this.environment.APP.VC_EVENT_DECORATOR_BASE_URL}/${this.serviceBaseUrl}/${id}`
        );
    }

    public upsert(filter: IFilterModel): Observable<number> {
        return this.httpClient.post<number>(
            `${this.environment.APP.VC_EVENT_DECORATOR_BASE_URL}/${this.serviceBaseUrl}`,
            filter
        );
    }

    public delete(id: number): Observable<void> {
        return this.httpClient.delete<void>(
            `${this.environment.APP.VC_EVENT_DECORATOR_BASE_URL}/${this.serviceBaseUrl}/${id}`
        );
    }
}
